// Projeto: Haklai Church — Plugin WordPress Modular - Desenvolvido por: Ricardo Sarmento - https://linx.pt

import { useState, useEffect } from 'react';

/**
 * Hook para detectar breakpoints responsivos
 * 
 * @param {string} query - Media query (ex: '(max-width: 991px)')
 * @returns {boolean} - true se a query corresponde
 * 
 * @example
 * const isMobile = useMediaQuery('(max-width: 991px)');
 * const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 991px)');
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches;
    }
    return false;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const mediaQuery = window.matchMedia(query);
    
    // Atualiza estado inicial
    setMatches(mediaQuery.matches);

    // Handler para mudanças
    const handler = (event) => {
      setMatches(event.matches);
    };

    // Adiciona listener (compatibilidade moderna e antiga)
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handler);
    } else {
      // Fallback para navegadores antigos
      mediaQuery.addListener(handler);
    }

    // Cleanup
    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handler);
      } else {
        mediaQuery.removeListener(handler);
      }
    };
  }, [query]);

  return matches;
}
